import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { LoadingProvider } from '../../providers/loading/loading';
import {EnvDataService} from '../../app/services/env-data-service';

@Component({
  selector: 'page-adf-customer-exist',
  templateUrl: 'adf-customer-exist.html',
  providers:[EnvDataService]
})
export class AdfCustomerExistPage {

  public accessPermissioncheckstatus : any;
  public accessPermissionname : any;
  public accessPermissioncheckstatusPS : any;
  public accessPermissionnamePS : any;
  public userRole: any;
  public allowCustomerEditPermissionStatus: any;
  public allowCustomerViewOnlyPermissionStatus: any;
  public contact_uid: any;
  public SDF_form_document_id: any;
  public accessPermission: any;
  public allowCustoeditPermission: any;
  public allowCustoViewOnlyPermission: any;
  public viewOnlyPermissionName: any;
  public editPermissionName: any;
  public reference_broker_uid: any;
  public broker_email: any;
  public customer_email: any;
  public customer_password: any;
  user_email:string;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http : Http,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public viewCtrl: ViewController,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService
  ) {
    this.broker_email = '';
    this.contact_uid = this.navParams.get("contact_uid");
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");

   


   
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad AllowCustomerPermissionPage');
  }

  getcustomerPermission (){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',this.contact_uid ).where('SDF_form_document_id','==',this.SDF_form_document_id )).valueChanges ();
  }

  getUserDetails(uid){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.contact_uid )).valueChanges ();
  }

  getBrokerDetails (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.reference_broker_uid )).valueChanges ();
  }

  closePopover(){
    window.localStorage.removeItem("contact_uid");
    window.localStorage.removeItem("contact_second_uid");
    this.viewCtrl.dismiss();
  }

 

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  
  submitEmail() {
    let data = {
      user_email:this.user_email,
    }
    this.viewCtrl.dismiss(data);
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/adf-customer-exist/adf-customer-exist.ts